
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4 text-tagblue">404</h1>
        <p className="text-xl text-gray-600 mb-4">This page is coming soon!</p>
        <p className="text-gray-500 mb-6">We're currently working on this section.</p>
        <Link to="/" className="bg-tagblue text-white px-6 py-2 rounded-lg hover:bg-tagblue-dark transition-colors">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
